<template>
  <Usuarios />
</template>

<script>
import Usuarios from '@/components/Usuarios/Usuarios.vue'
export default {
  name: 'UsuariosView',
  components: { Usuarios }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/UsuariosView.vue